module.exports = __webpack_public_path__ + "img/2011-4.8f72971f.jpg";